export enum ServiceType {
  LINEN_ROOM = 'LINEN_ROOM',
  SANITATION = 'SANITATION',
  MAINTENANCE = 'MAINTENANCE',
  NUTRITION = 'NUTRITION',
  OTHERS = 'OTHERS',
  SAC = 'SAC'
}
